// Unpublished Work © 2021-2022 Deere & Company

export const countriesWithTaxIds = {
    AUSTRALIA: 'AU',
    NEW_ZEALAND: 'NZ'
};

export const countriesWithoutTaxIds = {
    CANADA: 'CA',
    FIJI: 'FJ',
    PAPUA_NEW_GUINEA: 'PG',
    UNITED_STATES: 'US'
};

export const countryRegionCodes = {
    ARGENTINA: 'AR',
    AUSTRALIA: 'AU',
    CANADA: 'CA',
    FIJI: 'FJ',
    NEW_ZEALAND: 'NZ',
    PAPUA_NEW_GUINEA: 'PG',
    UNITED_STATES: 'US',
    BRAZIL: 'BR'
};

export const countryByRegion = {
    REGION_4: [
        countryRegionCodes.UNITED_STATES,
        countryRegionCodes.CANADA,
        countryRegionCodes.AUSTRALIA,
        countryRegionCodes.NEW_ZEALAND
    ]
};

export const countriesToShowTaxIds = [
    countryRegionCodes.ARGENTINA,
    countryRegionCodes.BRAZIL
];
